import React from 'react';
import { RouteConfig } from 'react-router-config';

import { PageRouteType, routePostProc } from '@/util/route';

/** ai客服 */
const AiKnowledgeBase = React.lazy(
  () => import('@/page/app/ai-knowledge/knowledge-base')
);

/** 智能客服语料 */
const AiKnowledgeCorpus = React.lazy(
  () => import('@/page/app/ai-knowledge/knowledge-corpus')
);

/** 知识库详情 */
const AiKnowledgeDetails = React.lazy(
  () => import('@/page/app/ai-knowledge/knowledge-corpus/knowledge-details')
);

/** 信息收集卡片配置 */
const TocCardConfig = React.lazy(
  () => import('@/page/app/ai-knowledge/knowledge-corpus/toc-card-config')
);

/** 智能分类 2.0 */
const KnowledgeSmartClassification = React.lazy(
  () => import('@/page/app/ai-knowledge/knowledge-smart-classification')
);

/** 智能体评估 */
const AgentEvaluation = React.lazy(
  () => import('@/page/app/ai-knowledge/agent-eval')
);

/** 智能体评估详情 */
const AgentEvaluationDetail = React.lazy(
  () => import('@/page/app/ai-knowledge/agent-eval/detail')
);

const SmartClassifyDetails = React.lazy(
  () =>
    import(
      '@/page/app/ai-knowledge/knowledge-smart-classification/classify-details'
    )
);

const AI_KNOWLEDGE_ROUTE: RouteConfig[] = [
  {
    path: '/base', // AI知识库页面
    component: AiKnowledgeBase,
  },
  {
    path: '/corpus', // 智能客服语料页面
    component: AiKnowledgeCorpus,
  },
  {
    path: '/details', // 知识库详情页面
    component: AiKnowledgeDetails,
  },
  {
    path: '/tocCardConfig',
    component: TocCardConfig,
  },
  {
    path: '/smartClassification',
    component: KnowledgeSmartClassification,
  },
  {
    path: '/agentEval',
    component: AgentEvaluation,
  },
  {
    path: '/agentEvalDetail',
    component: AgentEvaluationDetail,
  },
  {
    path: '/smartClassifyDetails',
    component: SmartClassifyDetails,
  },
];

export { AI_KNOWLEDGE_ROUTE };
export default routePostProc(PageRouteType.AI_KNOWLEDGE, AI_KNOWLEDGE_ROUTE);
